import { createSlice } from "@reduxjs/toolkit";

const socialAppSlice = createSlice({
  name: "socialAppSlice",
  initialState: {
    socialAppData: [],
    socialMediaSelectedAppId: 403061
  },
  reducers: {
    setSocialAppData: (state, action) => {
      state.socialAppData = action?.payload;
    },
    setSocialMediaSelectedAppId: (state, action) => {
      state.socialMediaSelectedAppId = action?.payload
    },
    clearSocialAppData: (state, action) => {
      state.socialAppData = []
      state.socialMediaSelectedAppId = null
    }
  },
});

// this is for dispatch
export const { setSocialAppData, setSocialMediaSelectedAppId, clearSocialAppData } = socialAppSlice.actions;

// this is for configureStore
export default socialAppSlice.reducer;
